export const cleanPhoneNumber = (countryCode: string, phoneNumber: string): string => {
    // Remove any non-digit characters (including the "+" sign)
    const cleanedPhoneNumber = phoneNumber.replace(/[^\d]/g, '');

    // If the phone number has a leading 0, remove it
    const cleaned = cleanedPhoneNumber.startsWith('0') ? cleanedPhoneNumber.slice(1) : cleanedPhoneNumber;

    // Ensure the "+" sign is at the beginning and return the full phone number with the country code
    return `+${countryCode}${cleaned}`;
}

export const cleanPhoneNumberOnlyDigits = (phone: string): string => {
    return phone.replace(/[^\d]/g, ''); // Removes everything except digits
}